import React, { useState } from "react";
import MobileViewImage from "../../assets/icons/MobileViewImage.png";
import GooglePlayStore from "../../assets/icons/play-store.png";
import AppleAppStore from "../../assets/icons/app-store.png";
import { Dialog, DialogTitle, DialogActions, Button } from "@mui/material";
import { useTranslation } from "react-i18next";


const MobileView = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleStoreClick = () => {
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };
  const { i18n } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="text-center">
        <p className="mb-4">
          {i18n.t("MOBILE_VIEW.NOKI_AVAILABLE")}
        </p>
        <img
          src={MobileViewImage}
          width="80%"
          alt="Desktop and mobile devices"
          className="mb-4"
        />
      </div>
      <div
        style={{
          border: "1px solid #6B488B",
          borderRadius: "8px",
          padding: "3% 10%",
        }}
      >
        <p className="text-sm text-center mb-3">
          {i18n.t("MOBILE_VIEW.STAY_TUNED")}
        </p>
        <div className="flex justify-center">
          <img
            src={GooglePlayStore}
            width={"45%"}
            alt="Google Play"
            onClick={handleStoreClick}
            style={{ cursor: "pointer" }}
          />
          <img
            src={AppleAppStore}
            width={"45%"}
            alt="App Store"
            style={{ marginLeft: "5%", cursor: "pointer" }}
            onClick={handleStoreClick}
          />
        </div>
      </div>
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">{i18n.t("MOBILE_VIEW.COMING_SOON")}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MobileView;
